import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/asks', { params })
}

export const show = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/asks/${id}`, { params })
}

/**
 *
 * @param params
 */
export const store = (params = {}): AxiosPromise => {
  return axios.post('/asks', params)
}

/**
 *
 * @param id
 * @param params
 */
export const update = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/asks/${id}`, params)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/asks/${id}/attribute`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/asks/${id}`)
}
